var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 12,
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 6.25L7.4063 5.32496C7.46108 5.28114 7.53892 5.28114 7.5937 5.32496L8.75 6.25",
    stroke: "#222222"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.5V5.25",
    stroke: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.8125 4.65C2.8125 3.80992 2.8125 3.38988 2.97599 3.06901C3.1198 2.78677 3.34927 2.5573 3.63151 2.41349C3.95238 2.25 4.37242 2.25 5.2125 2.25H5.66314C5.99373 2.25 6.15902 2.25 6.31219 2.29121C6.4479 2.32773 6.57614 2.3878 6.69107 2.46869C6.82078 2.55998 6.92659 2.68697 7.13821 2.94094L7.23679 3.05926C7.44841 3.31323 7.55422 3.44022 7.68393 3.53151C7.79886 3.6124 7.9271 3.67247 8.06281 3.70899C8.21598 3.7502 8.38127 3.7502 8.71186 3.7502H9.7875C10.6276 3.7502 11.0476 3.7502 11.3685 3.91369C11.6507 4.0575 11.8802 4.28697 12.024 4.56921C12.1875 4.89008 12.1875 5.31012 12.1875 6.1502V6.8502C12.1875 7.69028 12.1875 8.11032 12.024 8.43119C11.8802 8.71343 11.6507 8.9429 11.3685 9.08671C11.0476 9.2502 10.6276 9.2502 9.7875 9.2502H5.2125C4.37242 9.2502 3.95238 9.2502 3.63151 9.08671C3.34927 8.9429 3.1198 8.71343 2.97599 8.43119C2.8125 8.11032 2.8125 7.69028 2.8125 6.8502V4.65Z",
    stroke: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.a1a7a3c1ddd190ed63e618dc82698abe.svg";
export { ForwardRef as ReactComponent };